import { AlertComponent } from './alert/alert.component';
import { AvatarComponent } from './avatar/avatar.component';
import { CardCollapsableComponent } from './card-collapsable/card-collapsable.component';
import { CardIconComponent } from './card-icon/card-icon.component';
import { CardImageComponent } from './card-image/card-image.component';
import { CardNavigationComponent } from './card-navigation/card-navigation.component';
import { CardViewDetailsComponent } from './card-view-details/card-view-details.component';
import { CardComponent } from './card/card.component';
import { DropdownComponent } from './dropdown/dropdown.component';
import { LoremIpsumComponent } from './lorem-ipsum/lorem-ipsum.component';
import { ProgressbarComponent } from './progressbar/progressbar.component';
import { ProgresscardComponent } from './progresscard/progresscard.component';
import { ToastComponent } from './toast/toast.component';

export const components = [
    AlertComponent,
    CardCollapsableComponent,
    CardComponent,
    CardIconComponent,
    CardImageComponent,
    CardNavigationComponent,
    CardViewDetailsComponent,
    DropdownComponent,
    LoremIpsumComponent,
    ProgressbarComponent,
    ProgresscardComponent,
    ToastComponent,
    AvatarComponent,
];

export * from './alert/alert.component';
export * from './card-collapsable/card-collapsable.component';
export * from './card-icon/card-icon.component';
export * from './card-image/card-image.component';
export * from './card-navigation/card-navigation.component';
export * from './card-view-details/card-view-details.component';
export * from './card/card.component';
export * from './dropdown/dropdown.component';
export * from './lorem-ipsum/lorem-ipsum.component';
export * from './progressbar/progressbar.component';
export * from './progresscard/progresscard.component';
export * from './toast/toast.component';
export * from './avatar/avatar.component';
